import {
  Avatar,
  Backdrop,
  Box,
  Button,
  Chip,
  Divider,
  Grid,
  Hidden,
  IconButton,
  Link,
  Modal,
  Typography,
  useTheme
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { ArmyListLink, userDisplayName } from "../EventFunctions";
import { useEffect, useState } from "react";
import { EventSoftScorePlayerEntry } from "./EventSoftScoreComponents";
import {
  BCPChair,
  BCPCircleCheck,
  BCPEllipsisVertical,
  BCPXmark
} from "../../../../components/icons/bcp/BCPIcons";
import { getEnvironmentVariable } from "../../../../global/environmentVariables";
import { hexToRGB } from "../../../../components/utilities/UtilityFunctions";

const IS_WARMACHINE = getEnvironmentVariable("COMPANY_FLAG") === "wm";

export function SeatedRow(props) {
  const { t } = useTranslation("translation", {
    keyPrefix: "components.EventPairings"
  });

  const {
    organize,
    row,
    setPairing,

    setPairingPopUp,
    setPlayer,

    setOptionsAnchorEl2,
    setOptionsAnchorEl6
  } = props;

  if (row.isPod) {
    return (
      <Grid
        item
        xs={12}
        hover
        sx={{
          backgroundColor: "table.headerBackground",
          color: "table.headerColor",
          minHeight: "30px",

          p: 1,
          mb: 1,
          border: "1px solid rgba(0, 0, 0, 0.12)",
          borderRadius: "4px",
          boxShadow: 1
        }}
      >
        {row.label !== undefined
          ? row.label
          : row.podNum
            ? `${t("bracket")} ${row.podNum}`
            : t("swissBracket")}
      </Grid>
    );
  }

  if (organize) {
    return (
      <Grid
        item
        xs={12}
        sx={{
          mb: 1,
          border: "1px solid rgba(0, 0, 0, 0.12)",
          borderRadius: 1,
          boxShadow: 1
        }}
      >
        <Box
          onClick={(e) => {
            setPairing(row);
            setPairingPopUp(row);
          }}
          sx={{
            p: 1,
            mb: 1,
            border: "1px solid rgba(0, 0, 0, 0.12)",
            borderTopLeftRadius: "4px",
            borderTopRightRadius: "4px",
            boxShadow: 1,
            "&:hover": {
              cursor: "pointer"
            },

            backgroundColor: "#545b62",
            color: "#fff"
          }}
        >
          <Grid container spacing={1}>
            <Grid item xs={12} textAlign="center">
              <Typography>
                {t("table")} {row.table}
              </Typography>
            </Grid>
          </Grid>
        </Box>
        {row?.seatedPlayers?.length > 0 &&
          row.seatedPlayers.map((seatedPlayer, index) => {
            return (
              <SeatedPlayerRow
                key={index}
                organize={organize}
                seatedPairing={row}
                row={{
                  ...seatedPlayer,
                  id: seatedPlayer?.playerId
                }}
                setPairing={setPairing}
                setPairingPopUp={setPairingPopUp}
                setPlayer={setPlayer}
                setOptionsAnchorEl6={setOptionsAnchorEl6}
              />
            );
          })}
      </Grid>
    );
  } else {
    return (
      <Grid
        item
        xs={12}
        sx={{
          mb: 1,
          border: "1px solid rgba(0, 0, 0, 0.12)",
          borderRadius: 1,
          boxShadow: 1
        }}
        onClick={() => {
          setPairing(row);
          setPairingPopUp(row);
        }}
      >
        <Box
          sx={{
            p: 1,
            mb: 1,
            border: "1px solid rgba(0, 0, 0, 0.12)",
            borderTopLeftRadius: "4px",
            borderTopRightRadius: "4px",
            boxShadow: 1,

            backgroundColor: "#545b62",
            color: "#fff"
          }}
        >
          <Grid container spacing={1}>
            <Grid item xs={12} textAlign="center">
              <Typography>
                {t("table")} {row.table}
              </Typography>
            </Grid>
          </Grid>
        </Box>

        {row?.seatedPlayers?.length > 0 &&
          row.seatedPlayers.map((seatedPlayer, index) => {
            return (
              <SeatedPlayerRow
                key={index}
                organize={organize}
                seatedPairing={row}
                row={seatedPlayer}
                setPairing={setPairing}
                setPairingPopUp={setPairingPopUp}
                setPlayer={setPlayer}
                setOptionsAnchorEl2={setOptionsAnchorEl2}
              />
            );
          })}
      </Grid>
    );
  }
}

export function DoublesRow(props) {
  const { t } = useTranslation("translation", {
    keyPrefix: "components.EventPairings"
  });

  const {
    organize,
    row,
    setTeamPairing,
    setTeamPlayer,
    event,
    setPairingPopUp,

    setOptionsAnchorEl5
  } = props;

  const theme = useTheme();

  if (row.isPod) {
    return (
      <Grid
        item
        xs={12}
        hover
        sx={{
          backgroundColor: "table.headerBackground",
          color: "table.headerColor",
          minHeight: "30px",

          p: 1,
          mb: 1,
          border: "1px solid rgba(0, 0, 0, 0.12)",
          borderRadius: "4px",
          boxShadow: 1
        }}
      >
        {row.label !== undefined
          ? row.label
          : row.podNum
            ? `${t("bracket")} ${row.podNum}`
            : t("swissBracket")}
      </Grid>
    );
  }
  let tempPairings = {
    team1: row?.teamPlayer1?.players ? [...row.teamPlayer1.players] : [],
    team2: row?.teamPlayer2?.players ? [...row.teamPlayer2.players] : []
  };

  while (tempPairings.team1.length !== tempPairings.team2.length) {
    if (tempPairings.team1.length > tempPairings.team2.length) {
      tempPairings.team2.push({ isPlaceholder: true, name: "----------" });
    } else if (tempPairings.team1.length < tempPairings.team2.length) {
      tempPairings.team1.push({ isPlaceholder: true, name: "----------" });
    }
  }

  const PlayerRows = () => {
    return (
      <Grid
        item
        xs={12}
        sx={{
          p: 1
        }}
      >
        <Grid container spacing={1}>
          {tempPairings.team1.map((child, index) => {
            return (
              <>
                <Grid
                  item
                  xs={6}
                  sx={{
                    textAlign: "start",
                    overflow: "hidden",
                    borderBottom: "1px solid rgba(0, 0, 0, 0.12)"
                  }}
                >
                  <Typography>
                    {tempPairings?.team1?.[index]?.name
                      ? tempPairings.team1[index].name
                      : tempPairings?.team1?.[index]?.user?.firstName
                        ? tempPairings.team1[index].user.firstName +
                          " " +
                          tempPairings?.team1?.[index]?.user?.lastName
                        : "--------"}
                  </Typography>

                  {!event.flags?.hideLists && (
                    <Typography variant="caption">
                      {IS_WARMACHINE &&
                      tempPairings?.team1?.[index]?.parentFaction
                        ? `${tempPairings?.team1?.[index]?.parentFaction} - `
                        : ""}
                      {tempPairings?.team1?.[index]?.armyName
                        ? tempPairings.team1[index].armyName
                        : tempPairings?.team1?.[index]?.faction?.name
                          ? tempPairings.team1[index].faction.name
                          : "--------"}
                    </Typography>
                  )}
                </Grid>
                <Grid
                  item
                  xs={6}
                  sx={{
                    textAlign: "end",
                    overflow: "hidden",
                    borderBottom: "1px solid rgba(0, 0, 0, 0.12)"
                  }}
                >
                  <Typography>
                    {tempPairings?.team2?.[index]?.name
                      ? tempPairings.team2[index].name
                      : tempPairings?.team2?.[index]?.user?.firstName
                        ? tempPairings.team2[index].user.firstName +
                          " " +
                          tempPairings?.team2?.[index]?.user?.lastName
                        : "--------"}
                  </Typography>

                  {!event.flags?.hideLists && (
                    <Typography variant="caption">
                      {IS_WARMACHINE &&
                      tempPairings?.team2?.[index]?.parentFaction
                        ? `${tempPairings?.team2?.[index]?.parentFaction} - `
                        : ""}
                      {tempPairings?.team2?.[index]?.armyName
                        ? tempPairings.team2[index].armyName
                        : tempPairings?.team2?.[index]?.faction?.name
                          ? tempPairings.team2[index].faction.name
                          : "--------"}
                    </Typography>
                  )}
                </Grid>
              </>
            );
          })}
        </Grid>
      </Grid>
    );
  };

  if (organize) {
    return (
      <Grid
        item
        xs={12}
        onClick={(e) => {
          setTeamPairing(row);
          setPairingPopUp(row);
        }}
        sx={{
          p: 1,
          mb: 1,
          border: "1px solid rgba(0, 0, 0, 0.12)",
          borderRadius: "4px",
          boxShadow: 1,
          "&:hover": {
            cursor: "pointer"
          }
        }}
      >
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <Grid
              container
              sx={{
                p: 1,
                mb: 1,
                border: "1px solid rgba(0, 0, 0, 0.12)",
                borderTopLeftRadius: "4px",
                borderTopRightRadius: "4px",
                boxShadow: 1,
                "&:hover": {
                  cursor: "pointer"
                },
                backgroundColor: "table.headerBackground",
                color: "table.headerColor"
              }}
              gap={1}
            >
              <Grid item sx={{ maxWidth: "50px" }}>
                <IconButton
                  sx={{
                    color: "info.contrastText",
                    backgroundColor: "info.main",
                    "&:hover": { backgroundColor: "info.dark" }
                  }}
                  onClick={(e) => {
                    e.stopPropagation();
                    setTeamPairing(row);
                    setTeamPlayer(row["teamPlayer1"]);
                    setOptionsAnchorEl5(e.currentTarget);
                  }}
                >
                  <BCPEllipsisVertical />
                </IconButton>
              </Grid>

              <Grid item xs sx={{ width: "auto" }}>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    flexDirection: "column",
                    alignItems: "start"
                  }}
                >
                  <PlayerResult
                    organize={organize}
                    pairing={row}
                    playerNo="teamPlayer1"
                    doublesEvent
                  />
                </Box>
              </Grid>
              <Grid
                item
                xs
                sx={{
                  width: "16.66%",
                  textAlign: "center"
                }}
              >
                <Typography>{row.table}</Typography>
                {row.isDone && (
                  <BCPCircleCheck color={theme?.palette?.success.main} />
                )}
                {Boolean(
                  !row.isDone &&
                    (row.player1?.game?.gameResult !== undefined ||
                      row.player2?.game?.gameResult !== undefined)
                ) && <Chip label="LIVE" size="small" color="info" />}
              </Grid>
              <Grid
                item
                xs
                sx={{
                  width: "auto",
                  textAlign: "right"
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    flexDirection: "column",
                    alignItems: "end"
                  }}
                >
                  <PlayerResult
                    organize={organize}
                    pairing={row}
                    playerNo="teamPlayer2"
                    doublesEvent
                  />
                </Box>
              </Grid>
              <Grid item sx={{ maxWidth: "50px" }}>
                <IconButton
                  sx={{
                    color: "info.contrastText",
                    backgroundColor: "info.main",
                    "&:hover": { backgroundColor: "info.dark" }
                  }}
                  onClick={(e) => {
                    e.stopPropagation();
                    setTeamPairing(row);
                    setTeamPlayer(row["teamPlayer2"]);
                    setOptionsAnchorEl5(e.currentTarget);
                  }}
                >
                  <BCPEllipsisVertical />
                </IconButton>
              </Grid>
            </Grid>
          </Grid>

          <PlayerRows />
        </Grid>
      </Grid>
    );
  } else {
    return (
      <Grid
        item
        xs={12}
        sx={{
          p: 1,
          mb: 1,
          border: "1px solid rgba(0, 0, 0, 0.12)",
          borderRadius: "4px",
          boxShadow: 1,
          cursor: "pointer"
        }}
        onClick={
          setTeamPairing && setPairingPopUp
            ? () => {
                setTeamPairing(row);
                setPairingPopUp(row);
              }
            : undefined
        }
      >
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <Grid
              container
              sx={{
                p: 1,
                mb: 1,
                border: "1px solid rgba(0, 0, 0, 0.12)",
                borderTopLeftRadius: "4px",
                borderTopRightRadius: "4px",
                boxShadow: 1,
                "&:hover": {
                  cursor: "pointer"
                },
                backgroundColor: "table.headerBackground",
                color: "table.headerColor"
              }}
            >
              <Grid item xs sx={{ width: "41.666667%" }}>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    flexDirection: "column",
                    alignItems: "start"
                  }}
                >
                  <PlayerResult
                    pairing={row}
                    playerNo="teamPlayer1"
                    doublesEvent
                  />
                </Box>
              </Grid>
              <Grid item xs sx={{ width: "16.66%", textAlign: "center" }}>
                <Typography>{row.table}</Typography>
                {row.isDone && (
                  <BCPCircleCheck color={theme?.palette?.success.main} />
                )}
                {Boolean(
                  !row.isDone &&
                    (row.player1?.game?.gameResult !== undefined ||
                      row.player2?.game?.gameResult !== undefined)
                ) && <Chip label="LIVE" size="small" color="info" />}
              </Grid>
              <Grid
                item
                xs
                sx={{
                  width: "41.666667%",
                  textAlign: "right"
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    flexDirection: "column",
                    alignItems: "end"
                  }}
                >
                  <PlayerResult
                    pairing={row}
                    playerNo="teamPlayer2"
                    doublesEvent
                  />
                </Box>
              </Grid>
            </Grid>
          </Grid>

          <PlayerRows />
        </Grid>
      </Grid>
    );
  }
}

export function AdepticonTeamRow(props) {
  const { t } = useTranslation("translation", {
    keyPrefix: "components.EventPairings"
  });

  const {
    organize,
    row,
    setPairing,
    setTeamPairing,
    setTeamPlayer,

    setPairingPopUp,
    setPlayer,

    setOptionsAnchorEl2,
    setOptionsAnchorEl5,
    event,

    authContext,
    postSoftScoreSubmit
  } = props;

  const theme = useTheme();

  const [mergedTeamPairing, setMergedTeamPairing] = useState(null);

  useEffect(() => {
    const newMergedTeamPairing = {
      isDone: row?.isDone && row?.secondaryTeamPairing?.isDone,
      table: `${row.table < 10 ? `0${row.table}` : row.table}-${
        row.secondaryTeamPairing.table < 10
          ? `0${row.secondaryTeamPairing.table}`
          : row.secondaryTeamPairing.table
      }`,
      table1: row.table,
      table2: row.secondaryTeamPairing?.table,
      round: row?.round,
      teamPlayer1: row?.teamPlayer1,
      player1Game: {
        gamePoints:
          (row?.player1Game?.gamePoints || 0) +
          (row?.secondaryTeamPairing?.player1Game?.gamePoints || 0)
      },

      teamPlayer2: row?.teamPlayer2,
      player2Game: {
        gamePoints:
          (row?.player2Game?.gamePoints || 0) +
          (row?.secondaryTeamPairing?.player2Game?.gamePoints || 0)
      },

      pairings: [
        ...(row?.pairings || []),
        ...(row?.secondaryTeamPairing?.pairings || [])
      ]
    };
    newMergedTeamPairing.player1Game.gameResult =
      newMergedTeamPairing.player1Game.gamePoints >
      newMergedTeamPairing.player2Game.gamePoints
        ? 2
        : newMergedTeamPairing.player1Game.gamePoints <
            newMergedTeamPairing.player2Game.gamePoints
          ? 0
          : 1;

    newMergedTeamPairing.player2Game.gameResult =
      newMergedTeamPairing.player2Game.gamePoints >
      newMergedTeamPairing.player1Game.gamePoints
        ? 2
        : newMergedTeamPairing.player2Game.gamePoints <
            newMergedTeamPairing.player1Game.gamePoints
          ? 0
          : 1;

    newMergedTeamPairing.pairings.sort((a, b) => {
      if (a.table !== b.table) {
        return a.table - b.table;
      }
      return a.primaryPairingId === a.id ? -1 : 1;
    });

    if (!newMergedTeamPairing.isDone) {
      delete newMergedTeamPairing.player1Game;
      delete newMergedTeamPairing.player2Game;
    }
    setMergedTeamPairing(newMergedTeamPairing);
  }, [row]);

  if (row.isPod) {
    return (
      <Grid
        item
        xs={12}
        hover
        sx={{
          backgroundColor: "table.headerBackground",
          color: "table.headerColor",
          minHeight: "30px",

          p: 1,
          mb: 1,
          border: "1px solid rgba(0, 0, 0, 0.12)",
          borderRadius: "4px",
          boxShadow: 1
        }}
      >
        {row.label !== undefined
          ? row.label
          : row.podNum
            ? `${t("bracket")} ${row.podNum}`
            : t("swissBracket")}
      </Grid>
    );
  }

  if (organize) {
    return (
      <Grid
        item
        xs={12}
        sx={{
          mb: 1,
          border: "1px solid rgba(0, 0, 0, 0.12)",
          borderRadius: 1,
          boxShadow: 1
        }}
      >
        <Box
          onClick={(e) => {
            setTeamPairing(row);
            setPairingPopUp(row);
          }}
          sx={{
            p: 1,
            mb: 1,
            border: "1px solid rgba(0, 0, 0, 0.12)",
            borderTopLeftRadius: "4px",
            borderTopRightRadius: "4px",
            boxShadow: 1,
            "&:hover": {
              cursor: "pointer"
            },

            backgroundColor: "table.headerBackground",
            color: "table.headerColor"
          }}
        >
          <Grid container spacing={1}>
            <Grid item sx={{ minWidth: "50px", maxWidth: "50px" }}>
              <Typography>
                {row.table < 10 ? `0${row.table}` : row.table}
              </Typography>

              {!!row.isDone && (
                <BCPCircleCheck color={theme?.palette?.success.main} />
              )}
            </Grid>
            <Grid item sx={{ maxWidth: "40px" }}>
              <Button
                sx={{
                  minWidth: "unset",
                  maxWidth: "30px",
                  color: "info.contrastText",
                  backgroundColor: "info.main",
                  "&:hover": { backgroundColor: "info.dark" }
                }}
                onClick={(e) => {
                  e.stopPropagation();
                  setTeamPairing(row);
                  setTeamPlayer(row["teamPlayer1"]);
                  setOptionsAnchorEl5(e.currentTarget);
                }}
              >
                <BCPEllipsisVertical />
              </Button>
            </Grid>

            <Grid item sx={{ flex: 1, maxWidth: "calc(50% - 65px" }}>
              <PlayerResult
                organize={organize}
                pairing={row}
                playerNo="teamPlayer1"
              />
            </Grid>

            <Grid item sx={{ maxWidth: "40px" }}>
              <Button
                sx={{
                  minWidth: "unset",
                  maxWidth: "30px",
                  color: "info.contrastText",
                  backgroundColor: "info.main",
                  "&:hover": { backgroundColor: "info.dark" }
                }}
                onClick={(e) => {
                  e.stopPropagation();
                  setTeamPairing(row);
                  setTeamPlayer(row["teamPlayer2"]);
                  setOptionsAnchorEl5(e.currentTarget);
                }}
              >
                <BCPEllipsisVertical />
              </Button>
            </Grid>
            <Grid item sx={{ flex: 1, maxWidth: "calc(50% - 65px" }}>
              <PlayerResult
                organize={organize}
                pairing={row}
                playerNo="teamPlayer2"
              />
            </Grid>
          </Grid>
        </Box>
        {row?.pairings?.length > 0 &&
          row.pairings.map((pairing, index) => {
            return (
              <PlayerRow
                key={index}
                organize={organize}
                row={pairing}
                setPairing={setPairing}
                setPairingPopUp={setPairingPopUp}
                setPlayer={setPlayer}
                setOptionsAnchorEl2={setOptionsAnchorEl2}
                team
                event={event}
                postSoftScoreSubmit={postSoftScoreSubmit}
              />
            );
          })}
      </Grid>
    );
  } else {
    return (
      <Grid
        item
        xs={12}
        sx={{
          mb: 1,
          border: "1px solid rgba(0, 0, 0, 0.12)",
          borderRadius: 1,
          boxShadow: 1
        }}
      >
        {mergedTeamPairing && (
          <Box
            sx={{
              p: 1,
              mb: 1,
              border: "1px solid rgba(0, 0, 0, 0.12)",
              borderTopLeftRadius: "4px",
              borderTopRightRadius: "4px",
              boxShadow: 1,

              backgroundColor: "table.headerBackground",
              color: "table.headerColor"
            }}
          >
            <Grid container spacing={1}>
              <Grid item sx={{ minWidth: "50px", maxWidth: "50px" }}>
                <Typography>{mergedTeamPairing.table}</Typography>

                {mergedTeamPairing.isDone && (
                  <BCPCircleCheck color={theme?.palette?.success.main} />
                )}
              </Grid>

              <Grid item sx={{ flex: 1, maxWidth: "calc(50% - 25px" }}>
                <PlayerResult
                  pairing={mergedTeamPairing}
                  playerNo="teamPlayer1"
                  adepticonTeamEvent
                />
              </Grid>

              <Grid item sx={{ flex: 1, maxWidth: "calc(50% - 25px" }}>
                <PlayerResult
                  pairing={mergedTeamPairing}
                  playerNo="teamPlayer2"
                  adepticonTeamEvent
                />
              </Grid>
            </Grid>
          </Box>
        )}

        {(mergedTeamPairing?.round >= 4 || event?.gameSystem?.code !== 1) &&
          (mergedTeamPairing?.teamPlayer1?.teamCaptainId ===
            authContext?.authState?.identity?.userId ||
            mergedTeamPairing?.teamPlayer2?.teamCaptainId ===
              authContext?.authState?.identity?.userId) && (
            <Grid container spacing={1}>
              <Grid item xs={12}>
                <Button
                  color="info"
                  variant="contained"
                  fullWidth
                  href={`/game/teamPairing/${row.id}`}
                >
                  Update Table {row.table} Pairings
                </Button>
              </Grid>
              <Grid item xs={12}>
                <Button
                  color="info"
                  variant="contained"
                  fullWidth
                  href={`/game/teamPairing/${row.secondaryTeamPairingId}`}
                >
                  Update Table {row.secondaryTeamPairing?.table} Pairings
                </Button>
              </Grid>
            </Grid>
          )}

        {mergedTeamPairing?.pairings?.length > 0 &&
          mergedTeamPairing.pairings.map((pairing, index) => {
            return (
              <PlayerRow
                key={index}
                row={pairing}
                setPairing={setPairing}
                setPairingPopUp={setPairingPopUp}
                setPlayer={setPlayer}
                setOptionsAnchorEl2={setOptionsAnchorEl2}
                event={event}
                team
                postSoftScoreSubmit={postSoftScoreSubmit}
              />
            );
          })}
      </Grid>
    );
  }
}

export function TeamRow(props) {
  const { t } = useTranslation("translation", {
    keyPrefix: "components.EventPairings"
  });

  const {
    organize,
    row,
    setPairing,
    setTeamPairing,
    setTeamPlayer,

    setPairingPopUp,
    setPlayer,

    setOptionsAnchorEl2,
    setOptionsAnchorEl5,
    event,

    postSoftScoreSubmit
  } = props;

  const theme = useTheme();

  if (row.isPod) {
    return (
      <Grid
        item
        xs={12}
        hover
        sx={{
          backgroundColor: "table.headerBackground",
          color: "table.headerColor",
          minHeight: "30px",

          p: 1,
          mb: 1,
          border: "1px solid rgba(0, 0, 0, 0.12)",
          borderRadius: "4px",
          boxShadow: 1
        }}
      >
        {row.label !== undefined
          ? row.label
          : row.podNum
            ? `${t("bracket")} ${row.podNum}`
            : t("swissBracket")}
      </Grid>
    );
  }

  if (organize) {
    return (
      <Grid
        item
        xs={12}
        sx={{
          mb: 1,
          border: "1px solid rgba(0, 0, 0, 0.12)",
          borderRadius: 1,
          boxShadow: 1
        }}
      >
        <Box
          onClick={(e) => {
            setTeamPairing(row);
            setPairingPopUp(row);
          }}
          sx={{
            p: 1,
            mb: 1,
            border: "1px solid rgba(0, 0, 0, 0.12)",
            borderTopLeftRadius: "4px",
            borderTopRightRadius: "4px",
            boxShadow: 1,
            "&:hover": {
              cursor: "pointer"
            },

            backgroundColor: "table.headerBackground",
            color: "table.headerColor"
          }}
        >
          <Grid container spacing={1}>
            <Grid item sx={{ minWidth: "50px", maxWidth: "50px" }}>
              <Typography>
                {row.table < 10 ? `0${row.table}` : row.table}
              </Typography>

              {row.isDone && (
                <BCPCircleCheck color={theme?.palette?.success.main} />
              )}
            </Grid>
            <Grid item sx={{ maxWidth: "40px" }}>
              <Button
                sx={{
                  minWidth: "unset",
                  maxWidth: "30px",
                  color: "info.contrastText",
                  backgroundColor: "info.main",
                  "&:hover": { backgroundColor: "info.dark" }
                }}
                onClick={(e) => {
                  e.stopPropagation();
                  setTeamPairing(row);
                  setTeamPlayer(row["teamPlayer1"]);
                  setOptionsAnchorEl5(e.currentTarget);
                }}
              >
                <BCPEllipsisVertical />
              </Button>
            </Grid>

            <Grid
              item
              sx={{
                flex: 1,
                maxWidth: "calc(50% - 65px)",
                overflowX: "hidden"
              }}
            >
              <PlayerResult
                organize={organize}
                pairing={row}
                playerNo="teamPlayer1"
              />
            </Grid>

            <Grid item sx={{ maxWidth: "40px" }}>
              <Button
                sx={{
                  minWidth: "unset",
                  maxWidth: "30px",
                  color: "info.contrastText",
                  backgroundColor: "info.main",
                  "&:hover": { backgroundColor: "info.dark" }
                }}
                onClick={(e) => {
                  e.stopPropagation();
                  setTeamPairing(row);
                  setTeamPlayer(row["teamPlayer2"]);
                  setOptionsAnchorEl5(e.currentTarget);
                }}
              >
                <BCPEllipsisVertical />
              </Button>
            </Grid>
            <Grid
              item
              sx={{
                flex: 1,
                maxWidth: "calc(50% - 65px)",
                overflowX: "hidden"
              }}
            >
              <PlayerResult
                organize={organize}
                pairing={row}
                playerNo="teamPlayer2"
              />
            </Grid>
          </Grid>
        </Box>
        {row?.pairings?.length > 0 &&
          row.pairings.map((pairing, index) => {
            return (
              <PlayerRow
                key={index}
                organize={organize}
                row={pairing}
                setPairing={setPairing}
                setPairingPopUp={setPairingPopUp}
                setPlayer={setPlayer}
                setOptionsAnchorEl2={setOptionsAnchorEl2}
                team
                event={event}
                postSoftScoreSubmit={postSoftScoreSubmit}
              />
            );
          })}
      </Grid>
    );
  } else {
    return (
      <Grid
        item
        xs={12}
        sx={{
          mb: 1,
          border: "1px solid rgba(0, 0, 0, 0.12)",
          borderRadius: 1,
          boxShadow: 1,
          cursor: "pointer"
        }}
        onClick={() => {
          setTeamPairing(row);
          setPairingPopUp(row);
        }}
      >
        <Box
          sx={{
            p: 1,
            mb: 1,
            border: "1px solid rgba(0, 0, 0, 0.12)",
            borderTopLeftRadius: "4px",
            borderTopRightRadius: "4px",
            boxShadow: 1,

            backgroundColor: "table.headerBackground",
            color: "table.headerColor"
          }}
        >
          <Grid container spacing={1}>
            <Grid item sx={{ minWidth: "50px", maxWidth: "50px" }}>
              <Typography>
                {row.table < 10 ? `0${row.table}` : row.table}
              </Typography>

              {row.isDone && (
                <BCPCircleCheck color={theme?.palette?.success.main} />
              )}
            </Grid>

            <Grid
              item
              sx={{
                flex: 1,
                maxWidth: "calc(50% - 25px)",
                overflowX: "hidden"
              }}
            >
              <PlayerResult pairing={row} playerNo="teamPlayer1" />
            </Grid>

            <Grid
              item
              sx={{
                flex: 1,
                maxWidth: "calc(50% - 25px)",
                overflowX: "hidden"
              }}
            >
              <PlayerResult pairing={row} playerNo="teamPlayer2" />
            </Grid>
          </Grid>
        </Box>

        {row?.pairings?.length > 0 &&
          row.pairings.map((pairing, index) => {
            return (
              <PlayerRow
                key={index}
                row={pairing}
                setPairing={setPairing}
                setPairingPopUp={setPairingPopUp}
                setPlayer={setPlayer}
                setOptionsAnchorEl2={setOptionsAnchorEl2}
                event={event}
                team
                postSoftScoreSubmit={postSoftScoreSubmit}
              />
            );
          })}
      </Grid>
    );
  }
}

export function PlayerRow(props) {
  const { t } = useTranslation("translation", {
    keyPrefix: "components.EventPairings"
  });

  const {
    organize,
    row,
    setPairing,
    setPairingPopUp,
    setPlayer,
    setOptionsAnchorEl2,
    event,
    postSoftScoreSubmit
  } = props;

  const [softScoreOpen, setSoftScoreOpen] = useState(null);

  if (row.isPod) {
    return (
      <Grid
        item
        xs={12}
        hover
        sx={{
          backgroundColor: "table.headerBackground",
          color: "table.headerColor",
          minHeight: "30px",

          p: 1,
          mb: 1,
          border: "1px solid rgba(0, 0, 0, 0.12)",
          borderRadius: "4px",
          boxShadow: 1
        }}
      >
        {row.label !== undefined
          ? row.label
          : row.podNum
            ? `${t("bracket")} ${row.podNum}`
            : t("swissBracket")}
      </Grid>
    );
  }
  if (organize) {
    return (
      <>
        <Grid
          item
          xs={12}
          onClick={(e) => {
            setPairing(row);
            setPairingPopUp(row);
          }}
          sx={{
            p: 1,
            "&:hover": {
              cursor: "pointer"
            }
          }}
        >
          <Grid container spacing={1}>
            <Grid item sx={{ flex: 1, maxWidth: "50px" }}>
              <Typography>
                {row.table < 10 ? `0${row.table}` : row.table}
              </Typography>
            </Grid>
            <Grid item sx={{ maxWidth: "40px" }}>
              <Button
                sx={{
                  minWidth: "unset",
                  maxWidth: "30px",
                  color: "info.contrastText",
                  backgroundColor: "info.main",
                  "&:hover": { backgroundColor: "info.dark" }
                }}
                onClick={(e) => {
                  e.stopPropagation();
                  setPairing(row);
                  setPlayer(row["player1"]);
                  setOptionsAnchorEl2(e.currentTarget);
                }}
              >
                <BCPEllipsisVertical />
              </Button>
            </Grid>
            <Grid item sx={{ flex: 1, maxWidth: "calc(50% - 65px" }}>
              <PlayerResultInRows
                organize={organize}
                event={event}
                pairing={row}
                playerNo="player1"
                setSoftScoreOpen={setSoftScoreOpen}
              />
            </Grid>
            <Grid
              item
              sx={{
                maxWidth: "40px"
              }}
            >
              <Button
                sx={{
                  minWidth: "unset",
                  maxWidth: "30px",
                  color: "info.contrastText",
                  backgroundColor: "info.main",
                  "&:hover": { backgroundColor: "info.dark" }
                }}
                onClick={(e) => {
                  e.stopPropagation();
                  setPairing(row);
                  setPlayer(row["player2"]);
                  setOptionsAnchorEl2(e.currentTarget);
                }}
              >
                <BCPEllipsisVertical />
              </Button>
            </Grid>
            <Grid item sx={{ flex: 1, maxWidth: "calc(50% - 65px" }}>
              <PlayerResultInRows
                organize={organize}
                event={event}
                pairing={row}
                playerNo="player2"
                setSoftScoreOpen={setSoftScoreOpen}
              />
            </Grid>
          </Grid>

          <Divider sx={{ mb: 1, mt: 1 }} />
        </Grid>
        {organize && softScoreOpen && (
          <Modal
            disableAutoFocus
            open={true}
            onClose={(e) => {
              setSoftScoreOpen(null);
            }}
            closeAfterTransition
            BackdropComponent={Backdrop}
            BackdropProps={{
              timeout: 500
            }}
          >
            <Box
              sx={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                width: "95vw",
                minHeight: "85vh",
                maxHeight: "85vh",
                overflowY: "scroll",
                bgcolor: "background.paper",
                border: "1px solid rgba(0, 0, 0, 0.12)",
                borderRadius: 1,
                boxShadow: 24,
                p: 4
              }}
            >
              <IconButton
                aria-label="cancel"
                color="error"
                sx={{ position: "absolute", top: "4px", right: "4px" }}
                onClick={() => {
                  setSoftScoreOpen(null);
                }}
              >
                <BCPXmark />
              </IconButton>
              <Grid
                container
                spacing={2}
                sx={{
                  pb: 1,
                  mb: 2,
                  borderBottom: "1px solid rgba(0, 0, 0, 0.12)"
                }}
              >
                <Grid item xs={12}>
                  <Typography variant="h4">
                    {softScoreOpen?.player?.firstName ||
                    softScoreOpen?.player?.user?.firstName ||
                    softScoreOpen?.player?.lastName ||
                    softScoreOpen?.player?.user?.lastName
                      ? `${
                          softScoreOpen?.player?.firstName ||
                          softScoreOpen?.player?.user?.firstName ||
                          ""
                        } ${
                          softScoreOpen?.player?.lastName ||
                          softScoreOpen?.player?.user?.lastName ||
                          ""
                        }`.trim()
                      : "--------"}
                  </Typography>
                  <Typography variant="h5">
                    {softScoreOpen?.softScore?.name}
                  </Typography>
                </Grid>
              </Grid>

              <Grid
                container
                spacing={2}
                sx={{
                  pb: 1,
                  mb: 2,
                  borderBottom: "1px solid rgba(0, 0, 0, 0.12)"
                }}
              >
                <Grid item xs={12}>
                  <Typography variant="h4" component="h2">
                    Scored
                  </Typography>
                </Grid>
              </Grid>

              <EventSoftScorePlayerEntry
                organize
                player={softScoreOpen?.player}
                softScorePairing={softScoreOpen}
                event={event}
                softScoreId={softScoreOpen?.softScore?.id}
                round={row?.round}
                parentParing={row}
                postPairingSubmit={postSoftScoreSubmit}
              />
            </Box>
          </Modal>
        )}
      </>
    );
  } else {
    return (
      <Grid
        item
        xs={12}
        sx={{
          p: 1
        }}
      >
        <Link
          href={`/game/${
            row?.pairingType ? row.pairingType.toLowerCase() : "pairing"
          }/${row.id}`}
          underline="none"
          sx={{ color: "inherit" }}
        >
          <Grid container spacing={1}>
            <Grid item sx={{ flex: 1, maxWidth: "50px" }}>
              <Typography>
                {row.table < 10 ? `0${row.table}` : row.table}
              </Typography>
            </Grid>
            <Grid item sx={{ flex: 1, maxWidth: "calc(50% - 25px" }}>
              <PlayerResultInRows
                event={event}
                pairing={row}
                playerNo="player1"
                setSoftScoreOpen={setSoftScoreOpen}
              />
            </Grid>
            <Grid item sx={{ flex: 1, maxWidth: "calc(50% - 25px" }}>
              <PlayerResultInRows
                event={event}
                pairing={row}
                playerNo="player2"
                setSoftScoreOpen={setSoftScoreOpen}
              />
            </Grid>
          </Grid>
        </Link>
        <Divider sx={{ mb: 1, mt: 1 }} />
      </Grid>
    );
  }
}

const getExtendedGroupName = (player) => {
  if (player?.extendedGroupName) {
    return player?.extendedGroupName;
  }
  if (player?.groupID && player?.groupName) {
    return `Group ${
      player?.groupID < 10 ? `0${player?.groupID}` : player?.groupID
    }: ${player?.groupName}`;
  }
  return undefined;
};

export function PlayerResultInRows(props) {
  const { event, playerNo, pairing, doublesEvent, organize, setSoftScoreOpen } =
    props;

  const theme = useTheme();

  const player = pairing[playerNo];
  const opponentId =
    playerNo === "player1"
      ? pairing.player2?.id
      : playerNo === "player2"
        ? pairing.player1?.id
        : playerNo === "teamPlayer1"
          ? pairing.teamPlayer2?.id
          : playerNo === "teamPlayer2"
            ? pairing.teamPlayer1?.id
            : undefined;
  const game = pairing[`${playerNo.replace("teamPlayer", "player")}Game`];

  var result = "";
  if (game?.result >= 2 || game?.gameResult >= 2) {
    result = "Win";
  } else if (game?.result === 1 || game?.gameResult === 1) {
    result = "Draw";
  } else {
    result = "Loss";
  }

  var color = result.toLowerCase();

  if (!doublesEvent && playerNo.startsWith("teamPlayer")) {
    color = "#fff";
  }

  const extendedGroupName = getExtendedGroupName(player);

  const name = player?.name
    ? player?.name
    : player?.id
      ? userDisplayName(
          player?.firstName || player?.user?.firstName,
          player?.lastName || player?.user?.lastName
        )
      : "--------";

  const SolforgeDisplay = () => {
    return (
      <Grid
        container
        spacing={1}
        alignItems="center"
        sx={{
          "& .MuiTypography-root": { fontSize: "16px", m: 0 },
          "& .MuiTypography-root:not(:first-child)": { fontSize: "14px", m: 0 }
        }}
      >
        {playerNo === "player1" && (
          <Grid item sx={{ maxWidth: "40px" }}>
            <Avatar
              alt={name}
              src={player?.profileImageUrl}
              sx={{ width: 30, height: 30 }}
            />
          </Grid>
        )}
        <Grid item sx={{ flex: 1 }}>
          <PlayerResultDisplay />
        </Grid>
        {playerNo === "player2" && (
          <Grid item sx={{ maxWidth: "40px", textAlign: "right" }}>
            <Avatar
              alt={name}
              src={player?.profileImageUrl}
              sx={{ width: 30, height: 30 }}
            />
          </Grid>
        )}
      </Grid>
    );
  };

  const PlayerResultDisplay = () => {
    return (
      <>
        {playerNo.startsWith("teamPlayer") && (
          <Typography variant="body1" gutterBottom>
            {player?.name || "--------"}
          </Typography>
        )}
        {!playerNo.startsWith("teamPlayer") && (
          <>
            <Hidden mdDown>
              <Typography variant="body1" gutterBottom>
                {player?.firstName ||
                player?.user?.firstName ||
                player?.lastName ||
                player?.user?.lastName
                  ? `${player?.firstName || player?.user?.firstName || ""} ${
                      player?.lastName || player?.user?.lastName || ""
                    }`.trim()
                  : "--------"}
              </Typography>
              {extendedGroupName && (
                <Typography variant="body1" gutterBottom>
                  {extendedGroupName}
                </Typography>
              )}
            </Hidden>
            <Hidden mdUp>
              {(player?.firstName || player?.user?.firstName) && (
                <Typography variant="body1" gutterBottom>
                  {player?.firstName || player?.user?.firstName || "--------"}
                </Typography>
              )}
              {(player?.lastName || player?.user?.lastName) && (
                <Typography variant="body1" gutterBottom>
                  {player?.lastName || player?.user?.lastName || "--------"}
                </Typography>
              )}
              {extendedGroupName && (
                <Typography variant="body1" gutterBottom>
                  {extendedGroupName}
                </Typography>
              )}
            </Hidden>
            {(organize || !event.flags?.hideLists) &&
              event?.gameSystem?.hasFactions && (
                <Typography variant="body2" gutterBottom>
                  {IS_WARMACHINE && player?.parentFaction
                    ? `${player?.parentFaction} - `
                    : ""}
                  {player?.army?.name ||
                    player?.armyName ||
                    player?.faction?.name ||
                    player?.faction ||
                    "--------"}
                </Typography>
              )}
            {(organize || !event.flags?.hideLists) &&
              (IS_WARMACHINE || event?.gameSystem?.subFactionsRequired) && (
                <Typography variant="body2" gutterBottom>
                  {game?.subFaction?.name ||
                    player?.subFaction?.name ||
                    player?.subFactionName ||
                    player?.subFaction ||
                    "--------"}
                </Typography>
              )}
          </>
        )}

        {game?.gameResult !== undefined && (
          <Typography
            variant="body2"
            gutterBottom
            sx={{ color: `${color}.main` }}
          >{`${result}${
            !IS_WARMACHINE && game?.gamePoints !== undefined
              ? `: ${game.gamePoints}`
              : ""
          }`}</Typography>
        )}

        {game?.result !== undefined && (
          <Typography
            variant="body2"
            gutterBottom
            sx={{ color: `${color}.main` }}
          >{`${result}${
            !IS_WARMACHINE && game?.points !== undefined
              ? `: ${game.points}`
              : ""
          }`}</Typography>
        )}

        {organize &&
          opponentId &&
          pairing[playerNo + "SoftScores"]?.length > 0 &&
          pairing[playerNo + "SoftScores"].map((softScorePairing) => (
            <Typography variant="body2" gutterBottom>
              <Link
                onClick={(e) => {
                  e.stopPropagation();
                  setSoftScoreOpen({
                    ...softScorePairing,
                    player: player,
                    byePlayer: !Boolean(player?.id)
                  });
                }}
                underline="none"
                sx={{
                  color: `${
                    softScorePairing.forceDefaults
                      ? "warning"
                      : softScorePairing.scores?.[0]?.value !== undefined
                        ? "success"
                        : "error"
                  }.main`
                }}
              >
                {softScorePairing.softScore?.name}
              </Link>
            </Typography>
          ))}
        {(organize || !event.flags?.hideLists) && (
          <Typography variant="body2" gutterBottom>
            <ArmyListLink event={event} player={player} dense />
            {organize && player?.fixedTable > 0 && (
              <BCPChair
                sx={{
                  fontSize: "14px",
                  marginLeft: "8px",
                  color: `${player?.fixedTable === pairing.table ? theme?.palette?.success.main : theme?.palette?.error.main}`
                }}
              />
            )}
          </Typography>
        )}
      </>
    );
  };

  if (organize) {
    return getEnvironmentVariable("COMPANY_FLAG") === "solforge" ? (
      <SolforgeDisplay />
    ) : (
      <PlayerResultDisplay />
    );
  } else {
    if (getEnvironmentVariable("COMPANY_FLAG") === "bcp") {
      return <PlayerResultDisplay />;
    }
    return (
      <Link
        href={`/game/${
          pairing?.pairingType ? pairing.pairingType.toLowerCase() : "pairing"
        }/${
          event?.adepticonTeamEvent && pairing.primaryPairingId
            ? pairing.primaryPairingId
            : pairing.id
        }`}
        underline="none"
        sx={{ color: "inherit" }}
      >
        {getEnvironmentVariable("COMPANY_FLAG") === "solforge" ? (
          <SolforgeDisplay />
        ) : (
          <PlayerResultDisplay />
        )}
      </Link>
    );
  }
}

export function SeatedPlayerRow(props) {
  const {
    organize,
    row,
    seatedPairing,
    setPairing,
    setPairingPopUp,
    setPlayer,
    setOptionsAnchorEl6
  } = props;

  const game = seatedPairing?.games?.[row.playerId];

  var result = "";
  if (game?.gameResult >= 2) {
    result = "Win";
  } else if (game?.gameResult === 1) {
    result = "Draw";
  } else {
    result = "Loss";
  }
  var color = result.toLowerCase();

  if (organize) {
    return (
      <Grid
        item
        xs={12}
        onClick={(e) => {
          setPairing(seatedPairing);
          setPairingPopUp(seatedPairing);
        }}
        sx={{
          p: 1,
          borderBottom: "1px solid rgba(0, 0, 0, 0.12)",
          "&:hover": {
            cursor: "pointer"
          }
        }}
      >
        <Grid container spacing={1}>
          <Grid item sx={{ width: "auto", flex: 1 }}>
            <Typography>
              {`${row?.playerName} ${
                row?.teamName || row?.team?.name
                  ? " - " + (row?.teamName || row?.team?.name)
                  : ""
              }`.trim()}
            </Typography>
            <Typography>{row?.seatName}</Typography>
          </Grid>
          {seatedPairing.isDone && (
            <Grid item sx={{ maxWidth: "auto" }}>
              <Typography sx={{ color: `${color}.main` }}>{`${result}${
                !IS_WARMACHINE && game?.gamePoints !== undefined
                  ? `: ${game.gamePoints}`
                  : ""
              }`}</Typography>
            </Grid>
          )}
          <Grid
            item
            sx={{
              maxWidth: "50px",
              textAlign: "right"
            }}
          >
            <IconButton
              sx={{
                color: "info.contrastText",
                backgroundColor: "info.main",
                "&:hover": { backgroundColor: "info.dark" }
              }}
              onClick={(e) => {
                e.stopPropagation();
                setPairing(seatedPairing);
                setPlayer(row);
                setOptionsAnchorEl6(e.currentTarget);
              }}
            >
              <BCPEllipsisVertical />
            </IconButton>
          </Grid>
        </Grid>
      </Grid>
    );
  } else {
    return (
      <Grid
        item
        xs={12}
        sx={{
          p: 1,
          borderBottom: "1px solid rgba(0, 0, 0, 0.12)",
          cursor: "pointer"
        }}
      >
        <Grid container spacing={1}>
          <Grid item sx={{ width: "auto", flex: 1 }}>
            <Typography>
              {" "}
              {`${row?.playerName} ${
                row?.teamName || row?.team?.name
                  ? " - " + (row?.teamName || row?.team?.name)
                  : ""
              }`.trim()}
            </Typography>
            <Typography>{row?.seatName}</Typography>
          </Grid>
          {seatedPairing.isDone && (
            <Grid item sx={{ maxWidth: "auto" }}>
              <Typography sx={{ color: `${color}.main` }}>{`${result}${
                !IS_WARMACHINE && game?.gamePoints !== undefined
                  ? `: ${game.gamePoints}`
                  : ""
              }`}</Typography>
            </Grid>
          )}
        </Grid>
      </Grid>
    );
  }
}

export function PlayerResult(props) {
  const { playerNo, pairing, doublesEvent, organize, adepticonTeamEvent } =
    props;
  const player = pairing[playerNo];
  const game = pairing[`${playerNo.replace("teamPlayer", "player")}Game`];
  const theme = useTheme();

  var result = "";
  if (game?.gameResult >= 2 || game?.result >= 2) {
    result = "Win";
  } else if (game?.gameResult === 1 || game?.result === 1) {
    result = "Draw";
  } else {
    result = "Loss";
  }
  var color = result.toLowerCase();

  if (!doublesEvent && playerNo.startsWith("teamPlayer")) {
    color = "#fff";
  }

  const name = player?.name
    ? player?.name
    : player?.id
      ? userDisplayName(
          player?.firstName || player?.user?.firstName,
          player?.lastName || player?.user?.lastName
        )
      : "--------";

  const textSx =
    getEnvironmentVariable("COMPANY_FLAG") === "bcp"
      ? {
          color: "#fff",
          backgroundColor:
            !doublesEvent && playerNo.startsWith("teamPlayer")
              ? ""
              : `rgba(${hexToRGB(theme.palette[color].main)}, .8)`,
          borderRadius: "4px",
          padding: "4px 8px",
          width: "fit-content"
        }
      : {};

  const SolforgeDisplay = () => {
    return (
      <Grid
        container
        spacing={1}
        alignItems="center"
        sx={{
          "& .MuiTypography-root": { fontSize: "16px", m: 0 },
          "& .MuiTypography-root:not(:first-child)": { fontSize: "14px", m: 0 }
        }}
      >
        {playerNo === "player1" && (
          <Grid item sx={{ maxWidth: "40px" }}>
            <Avatar
              alt={name}
              src={player?.profileImageUrl}
              sx={{ width: 30, height: 30 }}
            />
          </Grid>
        )}
        <Grid item sx={{ flex: 1 }}>
          <PlayerResultDisplay />
        </Grid>
        {playerNo === "player2" && (
          <Grid item sx={{ maxWidth: "40px", textAlign: "right" }}>
            <Avatar
              alt={name}
              src={player?.profileImageUrl}
              sx={{ width: 30, height: 30 }}
            />
          </Grid>
        )}
      </Grid>
    );
  };

  const PlayerResultDisplay = () => {
    return (
      <>
        <Typography>{name}</Typography>
        {game?.gameResult !== undefined ? (
          <Typography sx={{ color: `${color}.main`, ...textSx }}>{`${result}${
            !IS_WARMACHINE && game?.gamePoints !== undefined
              ? `: ${game.gamePoints}`
              : ""
          }`}</Typography>
        ) : game?.result !== undefined ? (
          <Typography sx={{ color: `${color}.main`, ...textSx }}>{`${result}${
            !IS_WARMACHINE && game?.points !== undefined
              ? `: ${game.points}`
              : ""
          }`}</Typography>
        ) : (
          <></>
        )}
      </>
    );
  };

  if (organize) {
    return getEnvironmentVariable("COMPANY_FLAG") === "solforge" ? (
      <SolforgeDisplay />
    ) : (
      <PlayerResultDisplay />
    );
  } else if (adepticonTeamEvent) {
    return <PlayerResultDisplay />;
  } else {
    if (getEnvironmentVariable("COMPANY_FLAG") === "bcp") {
      return <PlayerResultDisplay />;
    }
    return (
      <Link
        href={`/game/${
          pairing?.pairingType ? pairing.pairingType.toLowerCase() : "pairing"
        }/${pairing.id}`}
        underline="none"
        sx={{ color: "inherit" }}
      >
        {getEnvironmentVariable("COMPANY_FLAG") === "solforge" ? (
          <SolforgeDisplay />
        ) : (
          <PlayerResultDisplay />
        )}
      </Link>
    );
  }
}
